import { render, staticRenderFns } from "./PayersPropertiesColumns.vue?vue&type=template&id=1b401c11&scoped=true"
import script from "./PayersPropertiesColumns.vue?vue&type=script&lang=js"
export * from "./PayersPropertiesColumns.vue?vue&type=script&lang=js"
import style0 from "./PayersPropertiesColumns.vue?vue&type=style&index=0&id=1b401c11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b401c11",
  null
  
)

export default component.exports